<template>
  <b-navbar class="navbar navbar-light bg-light">
    <b-navbar-brand href="#" :to="{ name: 'Home' }">
      <img src="@/assets/HRS_Virtual_Training_Logo.png" width="275px;"/>
    </b-navbar-brand>

    <b-navbar-nav class="ml-auto">
      <b-nav-item :to="{ name: 'Login' }" exact-active-class="active">Login</b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  data () {
    return { }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Login' })
      })
    }
  }
}
</script>
